import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Tabs, Tab, Box, IconButton, Drawer, List, ListItem, ListItemText, useMediaQuery, Theme, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import backgroundImage from '../src/assets/background.jpg';
import Contact from './pages/Contact';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const paths = ['/', '/experience', '/projects', '/contactMe'];
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const getIndex = () => paths.indexOf(location.pathname);

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh', 
        overflow: 'hidden', 
        backgroundImage: `url(${backgroundImage})`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center' 
      }}>
      <AppBar position="fixed" sx={{ backgroundColor: 'burlywood' }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {isSmallScreen ? (
            <>
              <IconButton onClick={handleDrawerToggle} color="inherit">
                <MenuIcon />
              </IconButton>
              <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle}>
                <List>
                  {paths.map((path, index) => (
                    <ListItem
                      button
                      key={path}
                      component={Link}
                      to={path}
                      onClick={() => setDrawerOpen(false)}
                      sx={{ color: 'darkblue' }} // Change text color for Drawer
                    >
                      <ListItemText
                        primary={
                          ['About Me', 'My Experience', 'Projects & Skills', 'Contact Me'][index]
                        }
                        primaryTypographyProps={{
                          fontSize: '18px', // Increase font size for Drawer items
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Drawer>
            </>
          ) : (
            <Tabs
              value={getIndex()}
              TabIndicatorProps={{ children: <span /> }}
              sx={{
                '& .MuiTab-root': {
                  fontSize: '18px',
                  color: 'darkblue',
                },
                '& .MuiTab-root.Mui-selected': {
                  color: 'darkred',
                },
              }}
            >
              <Tab label="About Me" component={Link} to="/" />
              <Tab label="My Experience" component={Link} to="/experience" />
              <Tab label="Projects & Skills" component={Link} to="/projects" />
              <Tab label="Contact Me" component={Link} to="/contactMe" />
            </Tabs>
          )}
        </Toolbar>
      </AppBar>


      <Box
        component="main"
        sx={{
          flexGrow: 1,
          padding: '20px',
          marginTop: '64px',
          overflowY: 'auto',
        }}
      >
        {children}
      </Box>

      <Box component="footer" sx={{ textAlign: 'center', padding: '10px', width: '100%' }}>
        <Contact />
      </Box>
    </Box>
  );
};

export default Layout;
